/**
 * FloatingActionButton Component - FAB with radial menu for tools
 * Provides quick access to tools on mobile devices
 */
import React, { useState } from 'react';
import { useProjectStore } from '../../stores';
import { useSidebarStore } from '../../store/sidebarStore';
import './FloatingActionButton.css';

interface FloatingActionButtonProps {
  onFiberTopologyClick: () => void;
  onInteractiveDesignClick: () => void;
  onAddCableClick: () => void;
}

export const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({
  onFiberTopologyClick,
  onInteractiveDesignClick,
  onAddCableClick,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { currentProject } = useProjectStore();
  const { toggleSidebar } = useSidebarStore();

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleAction = (action: () => void) => {
    action();
    setIsOpen(false);
  };

  return (
    <>
      {isOpen && (
        <div 
          className="fab-overlay" 
          onClick={() => setIsOpen(false)}
          aria-hidden="true"
        />
      )}
      
      <div className={`fab-container ${isOpen ? 'open' : ''}`}>
        {/* Radial menu items */}
        <button
          className="fab-menu-item fab-item-1"
          onClick={() => {
            toggleSidebar();
            setIsOpen(false);
          }}
          aria-label="Projekty"
          title="Projekty"
        >
          <span className="fab-menu-icon">📁</span>
          <span className="fab-menu-label">Projekty</span>
        </button>

        <button
          className="fab-menu-item fab-item-2"
          onClick={() => handleAction(onFiberTopologyClick)}
          disabled={!currentProject}
          aria-label="Vláknová Topológia"
          title="Vláknová Topológia"
        >
          <span className="fab-menu-icon">🔀</span>
          <span className="fab-menu-label">Topológia</span>
        </button>

        <button
          className="fab-menu-item fab-item-3"
          onClick={() => handleAction(onInteractiveDesignClick)}
          disabled={!currentProject}
          aria-label="Interaktívna Mapa"
          title="Interaktívna Mapa"
        >
          <span className="fab-menu-icon">🎨</span>
          <span className="fab-menu-label">Design</span>
        </button>

        <button
          className="fab-menu-item fab-item-4"
          onClick={() => handleAction(onAddCableClick)}
          disabled={!currentProject}
          aria-label="Pridať kábel"
          title="Pridať kábel"
        >
          <span className="fab-menu-icon">🔌</span>
          <span className="fab-menu-label">Kábel</span>
        </button>

        {/* Main FAB button */}
        <button
          className="fab-main"
          onClick={handleToggle}
          aria-label={isOpen ? 'Zavrieť menu' : 'Otvoriť menu'}
          aria-expanded={isOpen}
        >
          <span className={`fab-icon ${isOpen ? 'rotate' : ''}`}>
            {isOpen ? '✕' : '+'}
          </span>
        </button>
      </div>
    </>
  );
};
